import React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { TrustMemberAction } from "../../../../../../../Wrap/Constants/Enums/Customer/TrustMemberAction";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { TrustMemberHistory } from "../../../../../../../Wrap/Models/Models/Customer/TrustMemberHistory";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { Table } from "../../../../../../Shared/Table/Table";
import { ITrustMemberDetailsProps } from "../../../AddClient/Components/Organisation/TrustMemberDetails";
import { AddTrustMemberAction } from "../../AddTrustMember/Action/AddTrustMemberAction";
import { TrustMemberActionMap } from "../../Resource/Contents";

interface ITrustMemberHistoryLightboxProps {
    selectedMember: OrganisationMember;
    selectedMemberHistory: TrustMemberHistory[];
    isLoading: boolean;
}

interface ITrustMemberHistoryLightboxState {}

export class TrustMemberHistoryLightbox extends FormComponent<
    ITrustMemberHistoryLightboxProps,
    ITrustMemberHistoryLightboxState
> {
    constructor(props: ITrustMemberHistoryLightboxProps) {
        super(props);
        this.state = {};
    }
    componentDidMount() {}

    private isActiveMemberHistory(history: TrustMemberHistory) {
        if (
            history?.Action == TrustMemberAction.ActiveAsBeneiciary ||
            history?.Action == TrustMemberAction.ActiveAsSettlor ||
            history?.Action == TrustMemberAction.ActiveAsSignatory ||
            history?.Action == TrustMemberAction.ActiveAsTrustee
        ) {
            return true;
        } else {
            return false;
        }
    }

    private getHistoryConfig() {
        return [
            {
                title: "Change",
                key: "Action",
                render: (data: TrustMemberAction) => {
                    return TrustMemberActionMap[data];
                },
            },
            {
                title: "Updated by",
                key: "UpdatedUser",
                render: (data, row: TrustMemberHistory) => {
                    if (!data) {return "-";}
                    return row.UpdatedUser;
                },
            },
            {
                title: "Updated time",
                key: "UpdatedTime",
                render: (data, row) => {
                    if (!data) {return "-";}
                    return JsonDateParser.getFormatDateString(JsonDateParser.toDate(data), "dd/MM/yyyy hh:mm:ss");
                },
            },
            {
                title: "Authorised by",
                key: "AuthorisedUser",
                render: (data, row: TrustMemberHistory) => {
                    if (
                        this.isActiveMemberHistory(row) ||
                        row?.Action == TrustMemberAction.PendingAuthorisationAsTrustee ||
                        row?.Action == TrustMemberAction.PendingRemovalAsTrustee
                    ) {
                        return "-";
                    } else {
                        if (!data) {return "N/A";}
                        return row.AuthorisedUser;
                    }
                },
            },
            {
                title: "Authorised time",
                key: "AuthorisedTime",
                render: (data, row) => {
                    if (
                        this.isActiveMemberHistory(row) ||
                        row?.Action == TrustMemberAction.PendingAuthorisationAsTrustee ||
                        row?.Action == TrustMemberAction.PendingRemovalAsTrustee
                    ) {
                        return "-";
                    } else {
                        if (!data) {return "N/A";}
                        return JsonDateParser.getFormatDateString(JsonDateParser.toDate(data), "dd/MM/yyyy hh:mm:ss");
                    }
                },
            },
        ];
    }

    render() {
        const { selectedMember, selectedMemberHistory, isLoading } = this.props;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        return (
            <>
                {selectedMember?.Relationships.includes(RelationshipType.CorporateTrustee) && (
                    <h4>{selectedMember?.Company?.CompanyName}</h4>
                )}
                {!selectedMember?.Relationships.includes(RelationshipType.CorporateTrustee) && (
                    <h4>
                        {TitleMap.getString(selectedMember?.Individual?.PersonalDetails?.Title) +
                            " " +
                            selectedMember?.Individual?.PersonalDetails?.GivenName +
                            " " +
                            selectedMember?.Individual?.PersonalDetails?.FamilyName}
                    </h4>
                )}

                <Table
                    data={selectedMemberHistory}
                    col={this.getHistoryConfig()}
                    showEmptyMsg={true}
                    emptyMsg={"No audit history data exists for this Trust member"}
                />
            </>
        );
    }
}
